const contributor_types = {
    INVESTOR: 'INVESTOR',
    IDEATOR: 'IDEATOR',
}
export default contributor_types